var Backbone, EmailFormUSDateTimeInputView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

Backbone.$ = $;

EmailFormUSDateTimeInputView = (function(superClass) {
  extend(EmailFormUSDateTimeInputView, superClass);

  function EmailFormUSDateTimeInputView() {
    return EmailFormUSDateTimeInputView.__super__.constructor.apply(this, arguments);
  }

  EmailFormUSDateTimeInputView.prototype.tagName = 'li';

  EmailFormUSDateTimeInputView.prototype.events = {
    'change .date_time_input': 'validateEmailForm',
    'change .time_input_us': 'validateEmailForm'
  };

  EmailFormUSDateTimeInputView.prototype.initialize = function(options) {
    this.options = options || {};
    this.I18nScope = 'modules.support';
    this.isInputFieldEmpty = true;
    this.dateElementSelector = ".date_time_input";
    this.timeElementSelector = ".time_input_us";
    this.template = this.options.template;
    this.model = this.options.model;
    this.label = this.model.label;
    this.isInputCompulsory = this.model.required === true || this.model.required === "true";
    return this.showTimeInput = this.model.type === "date_time" || this.model.type === "calendar_with_hour_slot";
  };

  EmailFormUSDateTimeInputView.prototype.render = function() {
    this.$el.html(toHtml(this.template, this.toHash()));
    this.$el.find(this.dateElementSelector).datetimepicker(this.getDatePickerOptions());
    if (this.showTimeInput) {
      return this.$el.find(this.timeElementSelector).datetimepicker(this.getTimePickerOptions());
    }
  };

  EmailFormUSDateTimeInputView.prototype.getDatePickerOptions = function() {
    var options;
    return options = {
      format: 'm/d/Y',
      timepicker: false,
      closeOnDateSelect: true
    };
  };

  EmailFormUSDateTimeInputView.prototype.getTimePickerOptions = function() {
    var options;
    return options = {
      step: 30,
      format: 'g:i A',
      datepicker: false,
      formatTime: 'g:i A'
    };
  };

  EmailFormUSDateTimeInputView.prototype.toHash = function() {
    return {
      date_time_input_template: true,
      label: this.label,
      required: this.isInputCompulsory,
      showTimeInput: this.showTimeInput
    };
  };

  EmailFormUSDateTimeInputView.prototype.getDateInputHtmlElement = function() {
    return this.$el.find(this.dateElementSelector);
  };

  EmailFormUSDateTimeInputView.prototype.getTimeInputHtmlElement = function() {
    return this.$el.find(this.timeElementSelector);
  };

  EmailFormUSDateTimeInputView.prototype.isInputGiven = function() {
    if (this.showTimeInput) {
      return this.getDateInputHtmlElement().val().trim().length > 0 && this.getTimeInputHtmlElement().val().trim().length > 0;
    } else {
      return this.getDateInputHtmlElement().val().trim().length > 0;
    }
  };

  EmailFormUSDateTimeInputView.prototype.readInput = function() {
    var date, time;
    date = this.getDateInputHtmlElement().val().trim();
    time = this.showTimeInput ? this.getTimeInputHtmlElement().val().trim() : "";
    return (date + " " + time).trim();
  };

  EmailFormUSDateTimeInputView.prototype.isInputValid = function() {
    return true;
  };

  EmailFormUSDateTimeInputView.prototype.validateEmailForm = function() {
    if (this.isInputCompulsory && ((this.isInputFieldEmpty && this.isInputGiven()) || !(this.isInputFieldEmpty || this.isInputGiven()))) {
      this.isInputFieldEmpty = !this.isInputGiven();
      return this.options.validateEmailForm();
    }
  };

  EmailFormUSDateTimeInputView.prototype.populateInput = function(data) {
    var inputData;
    if (this.isInputGiven()) {
      inputData = this.readInput();
      return data.description += "\n\n " + this.label + " : " + inputData;
    }
  };

  return EmailFormUSDateTimeInputView;

})(Backbone.View);

module.exports = EmailFormUSDateTimeInputView;

//# sourceMappingURL=data:application/json;base64,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
